import { IEmailConta } from "../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";

import {
    AtualizarEmailContaService,
    CadastrarEmailContaService,
    DeletarEmailContaService,
    GetEmailContaService,
    ListarEmailContaService,
    ValidarEmailService,
} from "../../../../Services/Geral/GestaoDeCadastros/EmailConta/EmailContaService";

import { Controller } from "../../../Controller";

export async function CadastrarEmailContaContoller(requestBody: IEmailConta) {
    return Controller(CadastrarEmailContaService(requestBody));
}

export async function DeletarEmailContaController(idEmailConta: number) {
    return Controller(DeletarEmailContaService(idEmailConta));
}

export async function AtualizarEmailContaController(requestBody: IEmailConta) {
    return Controller(AtualizarEmailContaService(requestBody));
}

export async function ListarEmailContaController() {
    return Controller(ListarEmailContaService(0));
}

export async function ListarEmailContaComAcessoController() {
    return Controller(ListarEmailContaService(1));
}

export async function GetEmailContaController(idEmailConta: number) {
    return Controller(GetEmailContaService(idEmailConta));
}

export async function ValidarEmailController(idEmailConta: number) {
    return Controller(ValidarEmailService(idEmailConta));
}
